// Archivo para manejar las exportaciones de datos
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export const exportCSV = (data, filename = 'export.csv') => {
  const csvContent =
    'data:text/csv;charset=utf-8,' + data.map((row) => row.join(',')).join('\n')
  const encodedUri = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
}

export const exportExcel = (data, filename = 'export.xlsx') => {
  const ws = XLSX.utils.aoa_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
  XLSX.writeFile(wb, filename)
}

export const exportPDF = (data, filename = 'export.pdf') => {
  const doc = new jsPDF()
  autoTable(doc, {
    head: [Object.keys(data[0])],
    body: data.map((row) => Object.values(row)),
  })
  doc.save(filename)
}

export const exportImage = (tableId, filename = 'export.png') => {
  import('html2canvas').then((html2canvas) => {
    html2canvas.default(document.getElementById(tableId)).then((canvas) => {
      const link = document.createElement('a')
      link.href = canvas.toDataURL()
      link.download = filename
      link.click()
    })
  })
}
